module.exports = __webpack_public_path__ + "img/KM-360A_02.f0fbc0b7.jpg";